
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/average-decks/[commander]/[...slug]",
      function () {
        return require("private-next-pages/average-decks/[commander]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/average-decks/[commander]/[...slug]"])
      });
    }
  